import React, { useEffect, useState } from "react";
import { AxiosResponse, AxiosError } from "axios";
import { Result, activityCode } from "../../interface/ActivityCode";
import { ActivityCodeAxiosInstance } from "../../Network/ActivityCodeAxiosInstance";
import "react-toastify/dist/ReactToastify.css";
import { ColumnDef } from "@tanstack/react-table";
import { Button } from "../../components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
  } from "../../components/ui/dialog";
  import DataTable2 from "shared/DataTable2";
  import { Toaster } from "../../components/ui/toaster";
import { useToast } from "../../hooks/use-toast";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/Label";
const ActivityCodes: React.FC = () => {
  const [items, setItems] = useState<activityCode>({ result: [] });
  const [activity, setActivity] = useState<string>("");
  const [activityDescription, setActivityDescription] = useState<string>("");
  const [activityType, setActivityType] = useState<string>("");
  const [selectedActivity, setSelectedActivity] = useState<string | null>(null);
   // UI control states
    const [isDialogOpen, setIsDialogOpen] = useState(false);
   const [isEdit, setIsEdit] = useState<boolean>(false);

// Get token from localStorage
  const token = localStorage.getItem("token") || "";

   // Initialize toast
   const { toast } = useToast();

  useEffect(() => {
    console.log("Items:", items.result);
    fetchItems();
  }, []);

  const clear = () => {
 setActivity("");
 setActivityType("");
 setSelectedActivity(null);
 setIsEdit(false);

  };

  // Dialog control handlers
    const handleAddClick = () => {
          clear();
        setIsDialogOpen(true); }

          const handleEditClick = (item: Result) => {
            handleEdit(item);
            setIsDialogOpen(true); }

  // API functions
 
    const fetchItems = async (): Promise<void> => {
            try {
              const response: AxiosResponse<{ success: boolean; result: Result[] }> =
                await ActivityCodeAxiosInstance.get("getActivityCode");
              setItems({ result: [...response.data.result].sort((a: any, b: any) => b.id - a.id) });

              console.log(response.data.result);
            } catch (error) {
              console.error("Error fetching items:", error);
              toast({
                title: "Error",
                description: "Failed to fetch Activity Code",
              });
            }
          };

   const addItem = async (): Promise<void> => {
    try {
      const newGroup = {
        activity: activity,
        activity_description: activityDescription,
       activity_type: activityType,
        token: token,
      };

    const response = await ActivityCodeAxiosInstance.post("addActivityCode", newGroup);
 
   if (response.data.success) {
        fetchItems();
        clear();
        setIsDialogOpen(false);
        toast({
                title: "Success",
                description:  "Activity code added successfully.",
                });
      
      } else {
        toast({
                 title: "Error",
                description: response.data.error  || "An unexpected error occurred.",
                  });
   
      }
    } catch (error: AxiosError | any) {
      console.error("Error saving Activity code:", error);
      toast({
        title: "Error",
      description:
         error.response?.data?.error || "An unexpected error occurred.",
     });
    }
  };
  
  const handleEdit = (item: Result) => {
    setSelectedActivity(item.activity);
setIsDialogOpen(true);
  setActivity(item.activity);
  setActivityDescription(item.activity_description);
  setActivityType(item.activity_type);
  setIsEdit(true);
  };

  const updateItem = async (): Promise<void> => {
    try {
      if (!selectedActivity) {
        toast({
            title: "Error",
          description: "No Activity code selected for update",
         });
        return;
      }

      const updatedGroup = {
        oldactivity: selectedActivity,
        newactivity: activity,
        activity_description: activityDescription,
        activity_type: activityType,
        token,
      };

      const response = await ActivityCodeAxiosInstance.put(
        "updateActivitycode",
        updatedGroup
      );

      if (response.data.success) {
        fetchItems();
        clear();
        setIsDialogOpen(false);
        toast({
            title: "Success",
            description:  "Activity code updated successfully.",
         });

} else {
toast({
         title: "Error",
       description:
        response.data.error  || "An unexpected error occurred.",
      });

}
} catch (error: AxiosError | any) {
console.error("Error saving Activity code:", error);
toast({
title: "Error",
description:
error.response?.data?.error || "An unexpected error occurred.",
});
}
  };


  const removeItem = async (activity: string | number): Promise<void> => {
    console.log("Deleting ICD code with icd:", activity); 
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const response: AxiosResponse<{ success: boolean; message: string }> =
        await ActivityCodeAxiosInstance.delete(`deleteActivityCode/${activity}`, {
          headers,
          data: { token }, // Send the token in the body
        });

      if (response.data.success) {
        fetchItems();
        toast({
            title: "Success",
            description:  "Activity code deleted successfully.",
         });
      
      } else {
        toast({
            title: "Error",
          description:
           response.data.message  || "Failed to delete Activity code.",
         });
    
      }
    } catch (error: AxiosError | any) {
      console.error("Error removing ICD code:", error);
      toast({
        title: "Error",
      description:
      error.response?.data.error   || "Failed to delete Activity code.",
     });

    }
  };
  const columns: ColumnDef<Result>[] = [
    {
      accessorKey: "activity",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Activity
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },    {
      accessorKey: "activity_description",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Activity Description
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },
    {
      accessorKey: "activity_type",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Activity Type
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },
      {
         accessorKey: "actions",
         header: "Actions",
         cell: ({ row }) => (
           <div className="flex gap-2">
             <Button variant="outline" onClick={() => handleEdit(row.original)}>Edit</Button>
             <Button variant="destructive" onClick={() => removeItem(row.original.activity)}>
               Delete
             </Button>
           </div>
         ),
       },
  ];

  return (
    <div className="h5-container mx-auto px-1 pt-16 pb-4">


    <h5 className="mb-6 flex items-center gap-2" style={{fontWeight:"bolder" ,fontSize:"22px",  marginTop:"15px"}}>
    <span className="icon-container">
                  <i className="fa-solid fa-list"></i>
              </span>
              Activity Code
        </h5>
  

     <DataTable2
          columns={columns}
          data={items.result}
          searchColumns={["activity"]}
          addButtonLabel="Add Activity Code  "
          showAddButton={true}
          onAdd={handleAddClick}
          onEditClick={handleEditClick}
        />
      <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>
              {selectedActivity === null
                ? "Add Activity Code "
                : "Edit Activity Code "}
            </DialogTitle>
            <DialogDescription>
              Fill in the details below to{" "}
              {isEdit === null ? "create" : "update"} Activity Code .
            </DialogDescription>
          </DialogHeader>
          <div className="grid grid-cols-2 gap-4 mt-4">
      {/* First Column */}
      <div>

     <div className="mb-4">
              <Label htmlFor="custom_group_name">Type:</Label>
               <select
                className="form-select"
                value={activityType}
                onChange={(e) => setActivityType(e.target.value)}
              >
                <option value="">Select an Type</option>
                <option value="cpt">CPT</option>
                <option value="dental">Dental</option>
                <option value="hcpcs">HCPCS</option>
                <option value="drugs">Drugs</option>
                </select>
</div>                 
<div className="mb-4">

<Label htmlFor="activity_description">Activity Description</Label>
<Input
  id="activity_description"
  value={activityDescription}
  onChange={(e) => setActivityDescription(e.target.value)}  

  placeholder=" Activity Description is required  "
/>
</div>
</div>
      {/* Second Column */}
      <div>
      <div className="mb-4">

<Label htmlFor="activity">Activity Code</Label>
<Input
  id="activity"
  value={activity}
  onChange={(e) => setActivity(e.target.value)}  

  placeholder="Activity Code is required  "
/>
</div>
</div>
 </div>
         
<DialogFooter className="gap-2 m-4">
            <Button
               onClick={isEdit ? updateItem : addItem}
              className="bg-blue-600 hover:bg-blue-700"
            >
              {selectedActivity === null ? "Add Relation " : "Update Relation "}
            </Button>
            <Button
              variant="outline"
             
                onClick={(e) => { 
                  clear(); 
                  setIsDialogOpen(false);
                 }}
            >
              Cancel
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <Toaster />
    </div>
  );
};

export default ActivityCodes;